import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, queryParameters, renderRedirect, getJwtFromCookies, isExpiredJwt } from "../../module_auth/AuthService"
import { PaginationCustom } from "../common/PaginationCustom"
import { useNavigate } from "react-router-dom"
import { CmtyBaseTableRow } from './CmtyBaseTableRow';
import { isValidSearchPage } from '../../component/common/BaseUtil';
import { CTMY_REG_POST_URL, CTMY_HOME_URL } from './CmtyConstant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import '../../App.css'

export function CmtyBaseTable(props) {
    const navigate = useNavigate();

    const [tableRowList, setTableRowList] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");

    const [cmtyCatg, setCmtyCatg] = useState("");
    const [cmtyCatgUrl, setCmtyCatgUrl] = useState("");
    const [cmtyCatgUrlName, setCmtyCatgUrlName] = useState("");

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    const [returnUrl, setReturnUrl] = useState();

    useEffect(() => {
        setCmtyCatg(props.cmtyCatg)
        setCmtyCatgUrl(props.cmtyCatgUrl)
        setCmtyCatgUrlName(props.cmtyCatgUrlName)
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            //1.login
            setRedirectUrl('/login')
        } else {
            //1.cmty_reg_post
            setAccessToken(getJwtFromCookies())
            setRedirectUrl(CTMY_REG_POST_URL)
        }

        loadEntity()
    }, []);

    function loadEntity(){
        
        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        //end currentPage
        
        //navigate(props.cmtyUrl+"?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        let url = basePort + '/get/cmty/posts/' + props.cmtyCatg + '/' + currentPage
        let activePageIndex = (currentPage-1)%2
        if(next != null){
            url = basePort + '/get/cmty/posts/next/' + props.cmtyCatg + '/' + currentPage
            activePageIndex = (currentPage-1)%2
        } else if(previous != null) {
            url = basePort + '/get/cmty/posts/previous/' + props.cmtyCatg + '/' + currentPage
            activePageIndex = (currentPage-1)%2
        }
        
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
            setTableRowList(response.cardList)
            console.log(response.cardList)
            
            ////pagination
            setPageList(response.displayPages)
            setLastPage(response.lastPage)
            setActivePageIndex(activePageIndex)
            ////pagination

          }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        setRedirect(true)
    }

    function clickCmtyHome(event) {
        setRedirectUrl(CTMY_HOME_URL)
        setRedirect(true)
    }

    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
                <section>
                    <div class="container">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRowList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                    <div class="container" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                        <button class="btn btn-light btn-sm" type="button" style={{borderRadius: '5px',  marginRight:"5px"}} onClick={clickCmtyHome}>홈</button>
                        <PaginationCustom 
                            lastPage={lastPage}
                            page={page}
                            pageList={pageList}
                            activePageIndex={activePageIndex}
                            url={cmtyCatgUrlName}
                        />
                        <button class="btn btn-secondary btn-sm" type="button" style={{borderRadius: '5px'}} onClick={clickSubmit}>글쓰기</button>
                    </div>
                </section>
            </main>
        </div>
    );
}